import { lookupErrorCode, type ErrorService } from 'supabase-error-translator-js'

const IDIOMA = 'es'

// Mensajes propios para errores que conocemos por el diseño de nuestra base
const MENSAJES_PROPIOS: Record<string, string> = {
  '23P01': 'Esa empleada ya tiene un turno en ese horario.',
  '23505': 'Ya existe un registro con esos datos (por ejemplo, un cliente con el mismo WhatsApp).',
  '23503': 'No se puede borrar: tiene turnos en su historial.',
  '42501': 'No tienes permiso para hacer esto (o la suscripción del local está vencida).',
}

type ErrorSupabase = { code?: string; message?: string } | null | undefined

export function traducirError(error: ErrorSupabase, servicio: ErrorService): string {
  if (!error) return ''

  if (error.code) {
    if (servicio === 'database') {
      // P0001 = mensajes que lanzamos nosotros desde funciones de la base (ya están en español)
      if (error.code === 'P0001' && error.message) return error.message
      if (MENSAJES_PROPIOS[error.code]) return MENSAJES_PROPIOS[error.code]
    }
    const { message } = lookupErrorCode(error.code, servicio, IDIOMA)
    if (message) return message
  }

  console.error('Error sin traducción:', servicio, error)
  return 'Ocurrió un error inesperado. Intenta de nuevo.'
}